import React from 'react';
import {Link} from "react-router-dom";
import {UNIT} from "../../constants/routes";
import {getUnitID, getUnitName} from "../unit/utils";

/**
 * A component that encapsulates a unit
 * item to be displayed on a {@code NavbarAuthUnitDropdown} list
 */
export const UnitListItem = ({unit, onClick, selectedUnit}) => {
    const unitID = getUnitID(unit);
    return (
        <Link
            className={"dropdown-item bm-menu-item" + (selectedUnit && unitID === getUnitID(selectedUnit) ? " bg-primary" : "")}
            onClick={onClick(unit)}
            to={UNIT}
        >
            <i className="fas fa-car"/>{' ' + getUnitName(unit)}
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/components/navigationbar/UnitListItem.jsx